import { post ,getLonde} from "@/utils/http";
let url1 = 'statements/'
// 本地开发的默认前缀  127.0.0.1:8082/ ， 不需要单独添加， 如果转测试 去http.js 文件中修改前缀  http://127.0.0.1:8082//statements/getCurrentBillStatNo
class bill {
  // 全量确认对账单接口
  // http://localhost/cubc-msc-web/payStatement/confirmAllBill
  confirmAllBill() {
    return post(
        "payStatement/confirmAllBill",[]
    );
  }
  // http://localhost/cubc-msc-web/payStatement/checkConfirm
  // 查询本期账单所有未确认账单
  checkConfirm() {
    return post(
        "payStatement/checkConfirm",[]
    );
  } 
    // 查询手机号名下的客户编码
  // http://localhost/cubc-msc-web/contact/queryCustomerInfoList
  queryCustomerInfoList() {
    return post(
        "contact/queryCustomerInfoList"
    );
  } 
  // 切换客户编码登录
  // http://localhost/cubc-msc-web/contact/changeCustomer
  changeCustomer(parme) {
    return post(
        "contact/changeCustomer", parme
    );
  }
  //标记差异
  addDiffer(parme) {
    return post(
        "diffManagement/addDiff", parme
    );
  }

  //修改差异
  updateDiffer(parme) {
    return post(
        "diffManagement/modifyDiff", parme
    );
  }

  //查询差异
  selectDifferlist(parme) {
    return post(
        "diffManagement/queryDiff", parme
    );
  }
//删除差异
  deleteDiffer(parme){
    return post(
        "diffManagement/deleteDiff", parme
    );
  }
//获取结办人电话
  phone(parme){
    return post(
        "diffManagement/getFinishUserPhone ", parme
    );
  }

//批量查询差异
  getDiffersList(parme){
    return post(
        "diffManagement/getDiffs ", parme
    );
  }



  // 本期
  PaidBillRequest(parme) {
    return post(
      url1+"getCurrentBillStatNo", parme
    );
  }
  // 账单详情
  queryTradeDetailByStatNo(parme) {
    return post(
      url1+"queryTradeDetailByStatNo", parme
    );
  }
  // 运单详情
  queryWaybillTrack(parme) {
    return post(
      url1+"queryWaybillTrack", parme
    );
  }
  // 运单轨迹
  getInfoByWaybillNo(parme) {
    return post(
      url1+"getInfoByWaybillNo", parme
    );
  }
  // 全部
  queryAllBillStatement(parme) {
    return post(
      url1+"queryAllBillStatement", parme
    );
  }
  // 未出
  queryUnsettleTrade(parme) {
    return post(
      url1+"queryUnsettleTrade", parme
    );
  }
  // 未出 会计电话
  getMonthCustomerLeader() {
      return post(
        'clientManagement/getMonthCustomerLeader',
      );
  }
  // 获取邮箱
  //   http://127.0.0.1:8082/cubc-msc-web/clientManagement/getCustomerEmail
  // POST请求 无需传参 获取当前客户邮箱 
  getCustomerEmail() {
    return post(
      'clientManagement/getCustomerEmail'
    );
  }
  // 账单发送邮箱
  sendEmailExcel(parme) {
    return post(
      'statements/sendEmailExcel', parme
    );
  }
  // 下载账单
  startDownload(parme) {
    return post(
      'statements/startDownload', parme
    );
  }
  downloadFile(parme) {
    return post(
      'statements/downloadFile', parme
    );
  }
  downloadFile2(parme) {
    return getLonde(
      'statements/downloadFile', parme
    );
  }  
  // 未出账导出
  // http://127.0.0.1:8082/cubc-msc-web/statements/printUnsettleTrade
  // {
  //     "tableColumns":"{'sourceBillNo':'运单号','actionOrgName':'应收部门'}",
  //     "sourceBillNo": "",
  //     "startDate": "",
  //     "endDate": "",
  //     "currentPage": 1,
  //     "pageSize": 10
  // }
  printUnsettleTrade(parme) {
    return getLonde(
      'statements/printUnsettleTrade', parme
    );
  }
  // 确认支付
  confirmBillList(statementNoList) {
     return post(
         '/payStatement/confirmBillList',{statementNoList:statementNoList}
     );
  }
  // 创建支付订单
  createPayOrder(payAmount,statementNoList) {
    return post(
        '/payStatement/createPayOrder',{payAmount:payAmount, statementNoList:statementNoList}
    );
  }

  createTotalPayOrder(payAmount) {
    return post(
        '/payStatement/createTotalPayOrder',{payAmount:payAmount}
    );
  }
  // 查询是否支付
  queryIsPay(statBillNo) {
    return post(
        '/payStatement/confirmBillList',{statBillNo:statBillNo}
    );
  }



    //根据客户编码查询客户名下所有的联系人信息
    queryContactByCustomer() {
        return post(
            '/clientManagement/queryContactByCustomer',{}
        );
    }

    //获取验证码
    getVerificationCode(phoneNum) {
        return post(
            '/clientManagement/getVerificationCode',{phoneNum:phoneNum}
        );
    }

    //新增账号
    addNewContact(phoneNum) {
        return post(
            '/clientManagement/addNewContact',{phoneNum:phoneNum}
        );
    }


    //删除账号
    deleteContactInfo(id) {
        return post(
            '/clientManagement/deleteContactInfo',{id:id}
        );
    }
    //查询客户基础信息
    queryCustomerInfo(){
      return post(
          '/customer/queryCustomerInfo'
      );
    }
    // 退出
    logout() {
      return post(
          '/logout',{}
        );
    }
    // 电汇转账获取银行账号
  queryBankInfoByStatNoOrCustomerCode(parme) {
    return post(
      'payStatement/queryBankInfoByStatNoOrCustomerCode', parme
    );
  }

  // 创建单个支付单 
  createPmcPaymentOrder(payAmount,statementNoList) {
    return post('payStatement/createPaymentOrder  ', {payAmount:payAmount, statementNoList:statementNoList})
   }
   
   // 创建多个支付单 
   createPmcTotalPaymentOrder(payAmount) {
      return post('payStatement/createTotalPaymentOrder', {payAmount:payAmount})
   }
  // 电汇转账获取银行账号
  queryPCPromptSign(parme) {
    return post('statements/queryPCPromptSign', parme);
  }
  // 账单下载异步发起
  launchPCStatBillFile(parme) {
    return post('statements/launchPCStatBillFile', parme);
  }
  // 账单下载异步查询
  queryPCStatBillFile(parme) {
    return post('statements/queryPCStatBillFile', parme);
  }
  // 账单异步下载excel
  downloadPCStatBillFile(parme) {
    return getLonde('statements/downloadPCStatBillFile',parme);
  }
}

export default bill